module.exports = __webpack_public_path__ + "static/media/hanging_folder_black.52131d38.svg";